import { Box, Button, IconButton, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

interface StringListEditorProps {
  values: string[];
  onChange: (next: string[]) => void;
  addLabel: string;
  /** When true, the delete control is hidden if only one row remains. */
  retainAtLeastOneRow?: boolean;
  fieldLabel?: string;
}

/**
 * Repeating text fields with add/remove, used for root URLs and CSS removal lists.
 */
export function StringListEditor({
  values,
  onChange,
  addLabel,
  retainAtLeastOneRow = false,
  fieldLabel,
}: StringListEditorProps) {
  const showDelete = (index: number) =>
    !retainAtLeastOneRow || values.length > 1;

  return (
    <>
      {values.map((val, i) => (
        <Box key={i} sx={{ display: "flex", gap: 1, mb: 1 }}>
          <TextField
            fullWidth
            size="small"
            label={fieldLabel}
            value={val}
            onChange={(e) => {
              const next = [...values];
              next[i] = e.target.value;
              onChange(next);
            }}
          />
          {showDelete(i) && (
            <IconButton
              onClick={() => onChange(values.filter((_, j) => j !== i))}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </Box>
      ))}
      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={() => onChange([...values, ""])}
      >
        {addLabel}
      </Button>
    </>
  );
}
